import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import { get } from 'lodash';
import EventTypeForm from './EventTypeForm';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { CEntity } from '@ts/ui-models';
import { defaultConfigComponent } from './EventTypes';

//----------------------------------------------------------
const validationSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  customId: yup.string().required().label('Custom ID'),
});

const EventTypePage = props => {
  const dispatch = useAppDispatch();
  const eventsTypesList = useAppSelector(state => state.global.eventsTypesList);

  const updateEventTypesRedux = async (values, options: { itemId: string; responseData: any }) => {
    const entity = new CEntity(options.responseData);
    const newList = eventsTypesList.map(objeto => {
      const eventType = new CEntity(objeto);
      if (eventType.getID() === entity.getID()) {
        return options.responseData;
      }
      return objeto;
    });
    await dispatch(globalActions.updateGlobalState({ key: 'eventsTypesList', value: newList }));

    return;
  };

  return (
    <CrudPage
      key={'eventTypePage'}
      configComponent={defaultConfigComponent}
      form={EventTypeForm}
      defaultValues={{
        updatesItemsStatus: false,
        updatesItemTypesStatus: false,
        createsTasks: false,
        GPSRequired: false,
        distributes: false,
        enabled: false,
        replaceLocations: true,
        locationByEventRemove: false,
      }}
      validationSchema={validationSchema}
      //essentialValues={['taNotifConfig.data']}
      extraActionToDoAfterCorrectSubmit={updateEventTypesRedux}
    />
  );
};

export default EventTypePage;
